export const IMPROVE_BLEEDING_RISK = {
  masterTableName: "MC_IMPROVE_BLEEDING_RAST",
  tableName: "MC_IMPROVE_BLEEDING_RAST_DET",
  columnName: "IBR_ID",
  columnValue: 0,
  title: "improve-bleeding-risk.title",
  rows: [
    {
      title: "id",
      value: "ID",
    },
    {
      title: "date",
      value: "PROCESS_TIME",
      headerName: "Tarih",
      type: "date",
    },
    {
      title: "age",
      value: "AGE_XNAME",
    },
    {
      title: "gender",
      value: "GENDER_XNAME",
    },
    {
      title: "renal_failure",
      value: "KIDNEY_FAILURE_XNAME",
    },
    {
      title: "active_cancer",
      value: "ACTIVE_CANCER_XNAME",
    },
    {
      title: "rheumatic_disease",
      value: "RHEUMATIC_DISEASE_XNAME",
    },
    {
      title: "central_venous_catheter",
      value: "CENTRAL_VENOUS_CATHETER_XNAME",
    },
    {
      title: "icu_or_cardiac_icu",
      value: "YBU_XNAME",
    },
    {
      title: "liver_failure",
      value: "LIVER_FAILURE_XNAME",
    },
    {
      title: "platelet_count",
      value: "PLATELET_COUNT_XNAME",
    },
    {
      title: "bleeding_last_months",
      value: "BLEEDING_BEFORE_BEDTIME_XNAME",
    },
    {
      title: "active_gi_ulcer",
      value: "GASTROINTESTINAL_ULCER_XNAME",
    },
    {
      title: "total_score",
      value: "CALC_VALUE",
    },
  ],
  fields: [
    { field: "date", headerName: "datetime", flex: 1, type: "date" },
    { field: "age", headerName: "improve-bleeding-risk.age", flex: 1 },
    { field: "gender", headerName: "improve-bleeding-risk.gender", flex: 1 },
    {
      field: "renal_failure",
      headerName: "improve-bleeding-risk.renal-failure",
      flex: 1,
    },
    {
      field: "active_cancer",
      headerName: "improve-bleeding-risk.active-cancer",
      flex: 1,
    },
    {
      field: "rheumatic_disease",
      headerName: "improve-bleeding-risk.rheumatic-cisease",
      flex: 1,
    },
    {
      field: "central_venous_catheter",
      headerName: "improve-bleeding-risk.central-venous-catheter",
      flex: 1,
    },
    {
      field: "icu_or_cardiac_icu",
      headerName: "improve-bleeding-risk.icu-or-cardiac-icu",
      flex: 1,
    },
    {
      field: "liver_failure",
      headerName: "improve-bleeding-risk.liver-failure",
      flex: 1,
    },
    {
      field: "platelet_count",
      headerName: "improve-bleeding-risk.platelet-count",
      flex: 1,
    },
    {
      field: "bleeding_last_months",
      headerName: "improve-bleeding-risk.bleeding-in-last-months",
      flex: 1,
    },
    {
      field: "active_gi_ulcer",
      headerName: "improve-bleeding-risk.active-gastrointestinal-ulcer",
      flex: 1,
    },
    { field: "total_score", headerName: "score", flex: 1 },
  ],
  mcpConfig: {
    AGE: { mcpId: 734, field: "AGE", scoreField: "AGE" },
    GENDER: { mcpId: 724, field: "GENDER", scoreField: "GENDER" },
    KIDNEY_FAILURE: {
      mcpId: 725,
      field: "KIDNEY_FAILURE",
      scoreField: "KIDNEY_FAILURE",
    },
    ACTIVE_CANCER: {
      mcpId: 726,
      field: "ACTIVE_CANCER",
      scoreField: "ACTIVE_CANCER",
    },
    RHEUMATIC_DISEASE: {
      mcpId: 727,
      field: "RHEUMATIC_DISEASE",
      scoreField: "RHEUMATIC_DISEASE",
    },
    CENTRAL_VENOUS_CATHETER: {
      mcpId: 728,
      field: "CENTRAL_VENOUS_CATHETER",
      scoreField: "CENTRAL_VENOUS_CATHETER",
    },
    YBU: { mcpId: 729, field: "YBU", scoreField: "YBU" },
    LIVER_FAILURE: {
      mcpId: 730,
      field: "LIVER_FAILURE",
      scoreField: "LIVER_FAILURE",
    },
    PLATELET_COUNT: {
      mcpId: 731,
      field: "PLATELET_COUNT",
      scoreField: "PLATELET_COUNT",
    },
    BLEEDING_BEFORE_BEDTIME: {
      mcpId: 732,
      field: "BLEEDING_BEFORE_BEDTIME",
      scoreField: "BLEEDING_BEFORE_BEDTIME",
    },
    GASTROINTESTINAL_ULCER: {
      mcpId: 733,
      field: "GASTROINTESTINAL_ULCER",
      scoreField: "GASTROINTESTINAL_ULCER",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    IBR_ID: "",
    PROCESS_TIME: new Date(),
    CTIME: new Date(),
    CUSER: "",
    AGE: "",
    GENDER: "",
    KIDNEY_FAILURE: "",
    ACTIVE_CANCER: "",
    RHEUMATIC_DISEASE: "",
    CENTRAL_VENOUS_CATHETER: "",
    YBU: "",
    LIVER_FAILURE: "",
    PLATELET_COUNT: "",
    BLEEDING_BEFORE_BEDTIME: "",
    GASTROINTESTINAL_ULCER: "",
    CALC_VALUE: "",
  },
  chartScoreField: "CALC_VALUE",
  chartTimeField: "PROCESS_TIME",
};
